// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IssuesCloseOutlinedSvg from "@fishx/icons-svg/es/asn/IssuesCloseOutlined";
import FishxIcon from '../components/FishxIcon';

var IssuesCloseOutlined = function IssuesCloseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: IssuesCloseOutlinedSvg
  }));
};

IssuesCloseOutlined.displayName = 'IssuesCloseOutlined';
export default React.forwardRef(IssuesCloseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/IssuesCloseOutlined.js
// module id = 2995
// module chunks = 0